module.exports = __webpack_public_path__ + "static/media/10.141e5104.jpeg";